<script>
    export default {
        props: {
            selectedMarker: Object,
            dataConsumers: Array,
            selectedRouteInfo: Array,
        },
        data() {
            return {
                showRouteInfo: false,
                rutaSeleccionada: null,
                rutaSeleccionadaIndex: -1,
            };
        },
        methods: {
            closeInfo() {
                this.$emit('close');
            },
            showMarkerInfo(marker) {
                this.$emit('show-marker-info', marker);
            },
            calculateRoute(){
                this.showRouteInfo = true;
                this.$emit('calculate-route');
            },
            resetMap() {
                this.rutaSeleccionada = null;
                this.rutaSeleccionadaIndex = -1;
                this.showRouteInfo = false;
                this.$emit('reset-map');
            },
            selectRoute(route, index) {
                this.rutaSeleccionada = route;
                this.rutaSeleccionadaIndex = index;
                this.$emit('ruta-seleccionada', route);
            },

            
        },
    };
</script>
<template>
    <div class="marker-info">
        <div v-if="selectedMarker" >
            <button @click="closeInfo" class="close-button">X</button>

            <div class="title-marker-info">
                <h5>{{ selectedMarker.name }}</h5>
                <small>{{ selectedMarker.address }}</small>
            </div>

            <div v-if="!showRouteInfo">
                <b-tabs justified nav-class="nav-tabs-custom" content-class="text-muted"> 
                    <b-tab active>
                        <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                            <i class="fas fa-home"></i>
                        </span>
                        <span class="d-none d-sm-inline-block" style="font-size: small;">Datos generales</span>
                        </template>
                        <div class="data-company">
                            <div class="group group-1">
                                <div class="icon">
                                    <i class="fas fa-tags"></i>
                                </div>
                                <div class="content">
                                    <p>Sociedad: {{ selectedMarker.name }}</p>
                                </div>
                            </div>
                            <div class="group group-2">
                                <div class="icon">
                                    <i class="fas fa-map"></i>
                                </div>
                                <div class="content">
                                    <p>Ubicación: {{ selectedMarker.address }}</p>
                                    <p>Latitud: {{ selectedMarker.position.lat }}</p>
                                    <p>Longitud: {{ selectedMarker.position.lng }}</p>
                                </div>
                            </div>
                            <div class="group group-3">
                                <div class="icon">
                                    <i class="fas fa-map-marker-alt"></i>
                                </div>
                                <div class="content">
                                    <p>Comunidad: {{ selectedMarker.location.community }}</p>
                                    <p>Provincia: {{ selectedMarker.location.province }}</p>
                                    <p>Municipio: {{ selectedMarker.location.municipality }}</p>
                                    <p>Codigo Postal: {{ selectedMarker.postal_code }}</p>
                                </div>
                            </div>
                            <div class="group group-4">
                                <div class="icon">
                                    <i class="fas fa-tachometer-alt"></i>
                                </div>
                                <div class="content">
                                    <p>Tipo de energía: {{ selectedMarker.type }}</p>
                                </div>
                            </div>
                        </div>

                        <b-button @click="calculateRoute" pill size="sm" variant="primary" style="width: 100%;">Calcular ruta</b-button>
                        <!-- {{ text }} -->
                    </b-tab>


                    <b-tab>
                        <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                            <i class="far fa-user"></i>
                        </span>
                        <span class="d-none d-sm-inline-block" style="font-size: small;">Consumo</span>
                        </template>
                    </b-tab>
                </b-tabs>

            </div>
            <div v-else>
                <!-- <div v-for="route in selectedRouteInfo" :key="consumer.id">
                    
                </div> -->
                <div v-for="(route, index) in selectedRouteInfo" :key="index">
                    <div class="d-felx"
                            :class="{ 'ruta-seleccionada': index === rutaSeleccionadaIndex }"
                            @click="selectRoute(route, index)">
                        <div class="roads-info">  
                            <div class="roads">
                                <p><b>Por {{ route.summary }}</b></p>
                                <small>Coste: {{ route.legs[0].coste_kg }}€/Kg</small>
                                <!-- <small>Actualmente es la mejor ruta debido a las condiciones del tráfico</small> -->
                            </div>
                            <div class="info">
                                <p>{{ route.legs[0].duration.text }}</p>
                                <small>{{ route.legs[0].distance.text }}</small>
                            </div>
                        </div>
                    </div>
                </div>
                <b-button @click="resetMap" pill size="sm" variant="primary" style="width: 100%;">Volver a Datos Generales</b-button>
            </div>
            
        </div>
        <div v-else>
            <table  class="select-company-global" style="width: 100%;">
                <div class="company-global" v-for="consumer in dataConsumers" :key="consumer.id">
                    <a @click="showMarkerInfo(consumer)">
                        <tr class="col link">
                            <div class="content-left">
                                <td style="text-align: center;">
                                    <img v-bind:src=consumer.icon width="20px" height="20px"/>
                                </td>
                                <td class="select-company">{{ consumer.name }}<br><small>{{ consumer.address }}</small></td>
                            </div>
                            <div class="icon-right">
                                <td><i class="fa fa-chevron-right"></i></td>
                            </div>
                        </tr>
                    </a>
                </div>
            </table>
        </div>
    </div>
</template>
  
<style scoped>
    
    .link:hover {
        cursor: pointer;
        background-color: #f5f5f5; /* Cambia este color al que desees para el fondo de la fila cuando haces hover */
    }
    ul {
        list-style-type: none;
    }
    .close-button {
        position: absolute;
        top: 5px;
        right: 5px;
        background-color: transparent;
        border: none;
        cursor: pointer;
        font-size: 18px;
        line-height: 1;
    }
    .ruta-seleccionada {
        border-left: 3px solid blue; /* Línea vertical azul a la izquierda */
        background-color: #f0f0f0; /* Fondo resaltado */
    }
    .marker-info {
        position: absolute;
        left: 50px; /* Puedes ajustar la posición según tus necesidades */
        top: 100px; /* Puedes ajustar la posición según tus necesidades */
        background-color: white;
        padding: 35px;
        border: 1px solid #ccc;
        border-radius: 15px;
        width: 300px;
    }
    .data-company{
        margin: 30px 0px 10px 0px;
    }
    .title-marker-info {
        margin-bottom: 26px;
    }
    .title-marker-info h5{
        margin-bottom: 0px;
    }
    .title-marker-info small{
        color: #C7C7C7;
    }
    .marker-info .data-company .group{
        display:flex;
    }
    .marker-info .data-company .group .icon{
        padding-right: 10px;
        color: #0F1BC5;
    }
    .marker-info .data-company .group .content {
        margin-bottom: 20px;
    }
    .marker-info .data-company .group .content p {
        margin-bottom: 5px;
    }
    .p-3 {
        padding: 0rem !important;
    }
    span.d-none.d-sm-inline-block{
        margin: 5px -10px;
        font-weight: 900;
    }


    /* CALCULAR RUTA */
    .d-felx[data-v-73936e9f] {
        margin: 0px -35px;
        padding: 10px 35px;
        font-family: Inter;
        font-size: 15px;
        font-weight: 100 !important;  
    }

    .roads-info {
        display: flex;
        justify-content: space-between !important;
    }
    .info p{
        color: green;
        margin-bottom: -5px;
        font-weight: 900;  
    }
    .roads p{
        color: #000;
        margin-bottom: -5px;
    }
    .btn:not(:disabled):not(.disabled){
        margin-top: 25px;
    }
    .gm-style-iw-d p {
        color: green;
        margin: 50px !important;
    }
    .select-company{
        padding: 12px 0px;
    }
    .select-company-global{
        margin: -10px 0px -23px -5px;
    }
    .select-company-global img{
        width: 30px;
        height: 30px;
        margin-top: 10px;
    }
    .select-company{
        font-family: Inter;
        font-size: 15px;
        font-weight: 500; 
        padding-left: 10px;
        line-height: 1.2;
    }
    .select-company small{
        color: #C7C7C7;
        font-size: 12px;
        font-weight: 200;
    }
    .close-button[data-v-73936e9f]{
        top: 15px;
        right: 15px;
    }
    .icon-right{
        display: flex;
        margin-left: 225px;
        margin-top: -48px !important;
        margin-bottom: 25px;
    }
</style>
